
/**
 * Escapes input so they are not recognised as special regex characters.
 *
 * @param string
 * @returns {string}
 */

export const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
